<template>
  <Popper>
    <span class="filter-btn">
      <component :is="icon"> </component>
      <p>
        {{ title
        }}<span
          v-if="badge"
          data-testid="dropdown-filter-badge"
          class="ml-1 rounded-full bg-primary5 px-1.5 text-[9px] font-bold text-primary30"
          >{{ badge }}</span
        >
      </p>
    </span>
    <template #content>
      <!-- Adicionei rounded-md aqui para garantir que o conteúdo interno siga a borda -->
      <div class="max-h-[285px] py-[16px] bg-white rounded-md">
        <div
          v-if="withSearch"
          class="flex gap-1 items-center w-full text-[16px] font-normal px-[16px] pb-[16px]"
        >
          <input
            :placeholder="`Buscar ${title}`"
            class="w-full px-3 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-primary"
            v-model="searchValue"
          />
        </div>
        <div
          class="text-[14px] scrolbar-filter ds-scrollbar overflow-y-scroll pl-[16px] pr-[8px] max-h-[190px] text-left w-full h-full flex flex-col items-center font-normal"
        >
          <span
            v-for="item of itemsFiltered"
            :key="item.value"
            @click="$emit('clicked', item)"
            :class="[
              'w-full cursor-pointer p-[6px]',
              isSelected(item.value)
                ? 'bg-gray-100 font-semibold text-primary30'
                : 'text-gray-700 hover:bg-gray-100'
            ]"
          >
            {{ item.title }}
            <slot name="item-trailing" :item="item" />
            <span v-if="item.subtitle" class="block text-[11px] text-gray-400 font-normal">
              {{ item.subtitle }}
            </span>
          </span>
        </div>
      </div>
    </template>
  </Popper>
</template>

<script lang="ts">
import { computed, PropType, defineComponent, ref } from 'vue'
import Popper from 'vue3-popper'

export default defineComponent({
  components: {
    Popper
  },
  props: {
    withSearch: {
      type: Boolean,
      default: true
    },
    icon: {},
    title: {
      type: String,
      required: true
    },
    badge: {
      type: String,
      default: ''
    },
    items: {
      type: Array as PropType<{ title: string; value: string; subtitle?: string }[]>,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    selectedValue: {
      type: [String, Array] as PropType<string | string[] | null>,
      default: null
    }
  },
  emits: ['clicked'],
  setup(props) {
    const searchValue = ref('')
    const filterSearchFn = (item: { title: string; value: string; subtitle?: string }) => {
      const query = searchValue.value.toLowerCase()
      return item.title.toLowerCase().match(query) || item.subtitle?.toLowerCase().match(query)
    }
    const itemsFiltered = computed(() => props.items.filter(filterSearchFn))

    function isSelected(optionValue: string): boolean {
      if (!props.selectedValue) {
        return false
      }
      if (props.multiple && Array.isArray(props.selectedValue)) {
        return props.selectedValue.includes(optionValue)
      }
      if (!props.multiple && typeof props.selectedValue === 'string') {
        return props.selectedValue === optionValue
      }
      return false
    }

    return {
      searchValue,
      itemsFiltered,
      isSelected
    }
  }
})
</script>

<style scoped>
:deep(.popper) {
  --popper-theme-background-color: #ffffff;
  --popper-theme-background-color-hover: #ffffff;
  --popper-theme-text-color: #333333;
  --popper-theme-border-width: 1px;
  --popper-theme-border-style: solid;
  --popper-theme-border-color: #e5e7eb;
  --popper-theme-border-radius: 6px;
  --popper-theme-padding: 0;
  --popper-theme-box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}
</style>
